var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('p',{staticClass:"message"},[_vm._v("\n    "+_vm._s(_vm.$t('disabledModeScreen.message'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }